import { Dialog, DialogBody, DialogContent } from '@civilgrid/ui/components';
import type { RefObject } from 'react';
import { AdvancedSearch } from './AdvancedSearch';

interface AdvancedSearchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Takes focus on close: the option that opened the dialog is unmounted by then, so Radix has nothing to return to. */
  returnFocusTo: RefObject<HTMLButtonElement | null>;
}

export function AdvancedSearchDialog({ open, onOpenChange, returnFocusTo }: AdvancedSearchDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title="Advanced Search"
        className="z-[110] w-auto min-w-min max-w-[75vw]"
        overlayClassName="z-[100]"
        data-testid="advanced-search-dialog"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          returnFocusTo.current?.focus();
        }}
      >
        <DialogBody>
          <AdvancedSearch close={() => onOpenChange(false)} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
